function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var _require = require('preact'),
    h = _require.h,
    Component = _require.Component;

var AuthBlock =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(AuthBlock, _Component);

  function AuthBlock() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = AuthBlock.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this = this;

    setTimeout(function () {
      if (!_this.connectButton) return;

      _this.connectButton.focus({
        preventScroll: true
      });
    }, 150);
  };

  _proto.render = function render() {
    var _this2 = this;

    var pluginNameComponent = h("span", {
      class: "uppy-Provider-authTitleName"
    }, this.props.pluginName, h("br", null));
    return h("div", {
      class: "uppy-Provider-auth"
    }, h("div", {
      class: "uppy-Provider-authIcon"
    }, this.props.pluginIcon()), h("div", {
      class: "uppy-Provider-authTitle"
    }, this.props.i18nArray('authenticateWithTitle', {
      pluginName: pluginNameComponent
    })), h("button", {
      type: "button",
      class: "uppy-u-reset uppy-c-btn uppy-c-btn-primary uppy-Provider-authBtn",
      onclick: this.props.handleAuth,
      ref: function ref(el) {
        _this2.connectButton = el;
      }
    }, this.props.i18nArray('authenticateWith', {
      pluginName: this.props.pluginName
    })));
  };

  return AuthBlock;
}(Component);

var AuthView =
/*#__PURE__*/
function (_Component2) {
  _inheritsLoose(AuthView, _Component2);

  function AuthView() {
    return _Component2.apply(this, arguments) || this;
  }

  var _proto2 = AuthView.prototype;

  _proto2.render = function render() {
    return h(AuthBlock, this.props);
  };

  return AuthView;
}(Component);

module.exports = AuthView;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@uppy/provider-views/lib/AuthView.js
// module id = 1841
// module chunks = 2